import { Component, Injector } from '@angular/core';
import { ActivitiesServiceProxy } from '@shared/service-proxies/service-proxies';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { WidgetComponentBaseComponent } from '../widget-component-base';
import { LazyLoadEvent } from 'primeng/public_api';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';

@Component({
  selector: 'app-widget-download-submissions',
  templateUrl: './widget-download-submissions.component.html',
  styleUrls: ['./widget-download-submissions.component.scss'],
})
export class WidgetDownloadSubmissionsComponent extends WidgetComponentBaseComponent {
  constructor(
    injector: Injector,
    private _activitiesService: ActivitiesServiceProxy,
    private _fileDownloadService: FileDownloadService,
    private _projectService: ProjectService
  ) {
    super(injector);
  }
  async exportToExcel(event?: LazyLoadEvent) {
    const projectId = await this._projectService.getCurrentOrDefaultProjectId();
    this._activitiesService
      .getActivitiesForReportToExcel([], projectId)
      .subscribe((result) => {
        this._fileDownloadService.downloadTempFile(result);
      });
  }
}
